import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

import { CompanyListItem } from '../../models/company-list.model';
import { Pagination } from 'src/app/core/models/pagination.model';
import { CompanyCriteria } from '../../models/company.criteria';
import { CompanyService } from '../../services/company.service';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';
import { CompanyListRefresh } from '../../services/company-list.refresh';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  host: { 'class': 'content' }
})
export class CompanyComponent implements OnInit, OnDestroy {

  companies: CompanyListItem[] = [];
  pagination: Pagination;
  companyCriteria: CompanyCriteria = new CompanyCriteria();
  subscription: Subscription;

  isLoading: boolean = true;
  isLoadMoreVisible: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private progressBarService: ProgressBarService,
    private companyListRefresh: CompanyListRefresh
  ) { }

  ngOnInit() {
    const response: HttpResponse<CompanyListItem[]> = this.route.snapshot.data.companies;
    this.handleCompanyData(response);
    this.subscription = this.companyListRefresh.refresh$.subscribe(this.refresh);
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  onLoadMore() {
    this.companyCriteria.page = this.pagination.page + 1;
    this.progressBarService.start();
    this.companyService.get(this.companyCriteria.paramsExport())
      .subscribe(this.handleCompanyData);
  }

  createCompany() {
    this.router.navigate([{ outlets: { modal: 'create-company' } }]);
  }

  search(term: string) {
    this.companyCriteria.searchTerm = term;
    this.companyCriteria.page = 1;
    this.loadData();
  }

  activeFilter(filterTerm: string) {
    this.companyCriteria.filterActive = filterTerm;
    this.companyCriteria.page = 1;
    this.loadData();
  }

  refresh = () => {
    this.companyCriteria.page = 1;
    this.loadData();
  }

  private loadData() {
    this.progressBarService.start();
    this.companies = [];
    this.companyService.get(this.companyCriteria.paramsExport())
      .subscribe(this.handleCompanyData);
  }

  private handleCompanyData = (response: HttpResponse<CompanyListItem[]>) => {
    this.pagination = <Pagination>JSON.parse(response.headers.get('x-pagination'));
    this.companies = <CompanyListItem[]>[
      ...this.companies,
      ...response.body
    ];

    this.progressBarService.end();

    if (this.pagination.page != this.pagination.totalPages) {
      this.isLoadMoreVisible = true;
    } else {
      this.isLoadMoreVisible = false;
    }

    if (this.pagination.totalPages == 0) {
      this.isLoadMoreVisible = false;
    }
  }

}
